export const AI_TOOL_LOADING_SIZES = {
  /** Compact buttons: sample PDF, export/download PDF (~34–40px tall) */
  compact: 16,
  /** Full-width primary run buttons (~48px+ tall) */
  primary: 25,
}
